import { render, staticRenderFns } from "./edit-message-dialog.vue?vue&type=template&id=f3c52a0a&"
import script from "./edit-message-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports